// DYO vertical sliding gallery only

'use strict';

var Classnames = require('classnames');
var jQuery = require('jquery');
var React = require('react');

var Constants = require('../../constants/');
const DeviceImage = require('../../global/device-image.jsx');

var isNode = typeof document === 'undefined';
if (!isNode) {
    var requestAnimationFrame = require('requestanimationframe');
    require('./moma.scss');
}

var MomaTrack = React.createClass({
    // var STATE_INIT = 0;
    // var STATE_READY = 1;

    getInitialState: function() {
        var size = this.props.containerSize,
            x    = 0;
        
        if (this.props.proportion) {
            size *= this.props.proportion;
            x = -(size - ((this.props.containerSize - size) / 2));
        }

        return {
            currentX: x,
            size: size,

            cachedIx: this.props.ix,

            cache: [],
            startX: 0,
            endX: 0,
            startTime: Date.now(),
            endTime: Date.now(),
        };
    },
    componentWillMount: function() {
        this.state.cache[this.props.ix] = this.props.gallery[this.props.ix];

        // for proportional - show next slide
        this.state.cache[this.props.ix+1] = this.props.gallery[this.props.ix+1];
    },
    componentDidUpdate: function() {
        // The invariant /props.ix != state.cachedIx/ is true when new content needs to be loaded (props.ix changes)
        if (this.props.ix != this.state.cachedIx)
        {
            // if moving back onto an unloaded img, jump forward by one slide to get the scroll effect
            if ((this.props.ix == this.state.cachedIx - 1) && ((this.state.cache[this.props.ix] === undefined) ||
                  (this.props.ix > 1 && this.props.ix == this.state.cachedIx - 1 && this.state.cache[this.props.ix-2] === undefined)))
                  // last clause is for proportional
            {
                this.state.currentX -= this.state.size;
            }

            this.state.cache[this.props.ix] = this.props.gallery[this.props.ix];
            
            // for proportional - load previous 2
            this.state.cache[this.props.ix-1] = this.props.gallery[this.props.ix-1];
            this.state.cache[this.props.ix-2] = this.props.gallery[this.props.ix-2];

            if (this.props.ix+1 < this.props.gallery.length)
            {
                this.state.cache[this.props.ix+1] = this.props.gallery[this.props.ix+1];
            }

            this.state.cachedIx  = this.props.ix;
            this.state.startTime = Date.now();
            this.state.endTime   = Date.now() + 300;
            this.state.startX    = this.state.currentX;
            this.state.endX      = -this.calcIndex() * this.state.size;
            if (this.props.proportion) {
                this.state.endX -= this.state.size - ((this.props.containerSize - this.state.size) / 2);
            }

            requestAnimationFrame(this.tick);
        }
    },
    tick: function() {
        var now = Date.now();
        if (now < this.state.endTime)
        {
            var p = (now - this.state.startTime) / (this.state.endTime - this.state.startTime);
            p = p * (2 - p);  // Penner out quad easing

            var d = this.state.endX - this.state.startX;
            this.state.currentX = this.state.startX + (p * d);

            requestAnimationFrame(this.tick);
        }
        else
        {
            this.state.currentX = this.state.endX;
        }
        this.forceUpdate();
    },
    updateContainerSize: function(s) {
        // should be in componentDidUpdate() with state in parent passed through prop?
        var size = (this.props.proportion ? this.props.proportion * s : s),
            x    = -this.calcIndex() * size;
        
        if (this.props.proportion) {
            x -= this.state.size - ((this.props.containerSize - this.state.size) / 2);
        }
        this.setState({
            currentX: x,
            size: size
        });
    },
    calcIndex: function() {
        // this.state.cache is full of holes, so calculate the actual pixel offset
        var k = 0;
        for (var i = 0; i < this.props.ix; ++i)
        {
            if (this.state.cache[i])
            {
                ++k;
            }
        }
        return k;
    },
    render: function() {
        var _this = this,
            pre,
            post;

        var style = {
            height: this.state.size,
        };

        if (this.props.proportion !== undefined)
        {
            var data = this.props.gallery[this.props.gallery.length-1];
            pre = (
                <div className='moma-slide' key={data.id} style={style}>
                    {_this.props.slideContent(data)}
                    <div className='moma-mask'></div>
                </div>
            );

            var data = this.props.gallery[0];
            post = (
                <div className='moma-slide' key={data.id} style={style}>
                    {_this.props.slideContent(data)}
                    <div className='moma-mask'></div>
                </div>
            );
        }

        var slides = this.state.cache.map(function(data) {
            return (
                <div className='moma-slide' key={data.id} style={style}>
                    {_this.props.slideContent(data)}
                </div>
            );
        });

        var trackStyle;

        var trackSize = this.state.cache.length * this.state.size;
        if (this.props.proportion) {
            trackSize += this.state.size * 2;
        }

        trackStyle = {
            top: this.state.currentX,
            height: trackSize,
        };

        return (
            <div className='moma-track nosel' style={trackStyle}>
                {pre}
                {slides}
                {post}
            </div>
        );
    }
});


var Moma = {
    getInitialState: function() {
        return {
            ix: 0,
            containerSize: this.getContainerSize(),
        };
    },

    // Dimensions
    //
    getContainerSize: function() {
        if (this.props.containerClass) {
            return jQuery(this.props.containerClass).height();
        } else {
            return this.props.size;
        }
    },
    componentDidMount: function() {
        window.addEventListener('resize', this.updateDimensions);
    },
    componentWillUnmount: function() {
        window.removeEventListener('resize', this.updateDimensions);
    },
    updateDimensions: function() {
        var size = this.getContainerSize();
        this.setState({ containerSize: size });
        this.refs.track.updateContainerSize(size);
    },

    // Navigation
    //
    prevClick: function(event) {
        if (this.state.ix > 0) {
            this.navigateTo(this.state.ix - 1);
        } else {
            this.navigateTo(this.props.gallery.length - 1);
        }
    },
    nextClick: function(event) {
        if (this.state.ix < this.props.gallery.length-1) {
            this.navigateTo(this.state.ix + 1);
        } else {
            this.navigateTo(0);
        }
    },
    navigateTo(ix) {
        this.setState({ ix: ix });
        if (this.slideWillChange) {
            this.slideWillChange(ix, this.props.gallery[ix]);
        }
    },
    keyDown: function(ev) {
        if (ev.keyCode == 37) this.prevClick();
        if (ev.keyCode == 39) this.nextClick();
    },
    goTo: function(ix)
    {
        this.setState({ ix: ix });
    },

    // Autoplay
    //
    startAutoplay: function(seconds) {
        this.autoplay_secs = seconds;
        var _this = this;
        this.interval = setInterval(function() {
            _this.nextClick();
        }, seconds * 1000);
    },
    stopAutoplay: function() {
        clearInterval(this.interval);
    },

    render: function() {
        // var { coalesce, ...other } = this.props;

        var footer = this.footer && this.footer();

        var paneStyle = {
            height: this.state.containerSize,
        };

        var prevArrowClasses = Classnames({
            'moma-up':    true,
            'nosel':      true,
        });
        var nextArrowClass = Classnames({
            'moma-down':  true,
            'nosel':      true,
        });
        var prev, next;
        if (this.state.ix > 0 || this.props.loop) {
            prev = (
                <div onClick={this.prevClick} className={prevArrowClasses}>
                    <DeviceImage src='moma/nav-light-up.png' alt='previous' />
                </div>
            );
        }
        if (this.state.ix < this.props.gallery.length-1 || this.props.loop) {
            next = (
                <div onClick={this.nextClick} className={nextArrowClass}>
                    <DeviceImage src='moma/nav-light-down.png' alt='next' />
                </div>
            );
        }

        return (
            <div className="moma">
                <div className='moma-pane nosel' style={paneStyle}>
                    <MomaTrack {...this.props}
                               ref            = {'track'}
                               gallery        = {this.props.gallery}
                               ix             = {this.state.ix}
                               containerSize  = {this.state.containerSize}
                               height         = {this.props.height}
                               slideContent   = {this.slideContent}
                               slideClicked   = {this.slideClicked}
                               proportion     = {this.props.proportion} />
                    {footer}
                </div>

                <div className='moma-nav'>
                    {prev}
                    {next}
                </div>
            </div>
        );
    }
};

module.exports = Moma;



// WEBPACK FOOTER //
// ./src/plugins/legacy-moma/moma.jsx